import React from 'react';
import { Card, CardContent, Typography, Link, Box } from '@mui/material';

const AboutComponent = () => {
  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>
          About This Demo
        </Typography>

        {/* --- MODIFIED SECTION START --- */}
        <Typography variant="body2" color="text.secondary">
          A demo by the{' '}
          <Box component="span" sx={{ fontWeight: 'bold' }}>
            Machine Learning Group
          </Box>{' '}
          at{' '}
          <Box component="span" sx={{ fontWeight: 'bold' }}>
            Czech Technical University in Prague
          </Box>{' '}
          for the WACV 2026 paper:
        </Typography>
        {/* --- MODIFIED SECTION END --- */}
        <Typography variant="body1" sx={{ my: 1, fontWeight: 'bold' }}>
          Photo Dating by Facial Age Aggregation
        </Typography>
        <Typography variant="body2" color="text.secondary">
          It estimates when a photo was taken based on the faces of the people in it.
        </Typography>

        {/* --- MODIFIED SECTION START --- */}
        <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Link
            href="[Link to your arXiv paper]" // TODO: Update this link
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            Paper
          </Link>
          <Link
            href="[Link to your GitHub repo]" // TODO: Update this link
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            Dataset
          </Link>
          {/* This is the new link for your group */}
          <Link
            href="https://cyber.felk.cvut.cz/research/groups-teams/ml/" // TODO: Update this link
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            University Group
          </Link>
        </Box>
        {/* --- MODIFIED SECTION END --- */}

      </CardContent>
    </Card>
  );
};

// The LimitationsComponent remains unchanged
export const LimitationsComponent = () => {
  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>
          Limitations
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This is a research prototype. Accuracy may vary based on image quality, face visibility, and whether individuals are known to the model. The model may reflect demographic biases of training datasets.
        </Typography>
      </CardContent>
    </Card>
  );
}

export default AboutComponent;